import { render } from "./planeamentoForm.vue?vue&type=template&id=54ab6d6e&scoped=true"
import script from "./planeamentoForm.vue?vue&type=script&lang=js"
export * from "./planeamentoForm.vue?vue&type=script&lang=js"

import "./planeamentoForm.vue?vue&type=style&index=0&id=54ab6d6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ab6d6e"]])

export default __exports__